import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Page, WpLangContentPage } from 'src/app/shared/models/paging/page';
import { environment } from 'src/environments/environment';
import { WPLangContent } from './multi-language.model';
import { ReturnResult } from 'src/app/shared/models/return-result';
import { RemoveAtionIdList } from '../profile-management/profile-detail.model';

@Injectable({
  providedIn: 'root'
})
export class MultiLanguageManagementService {

  baseUrl = environment.apiWpLangContent;
  constructor(private http: HttpClient) { }

  getLanguage() {
    return this.http.get<[]>('./assets/language.json');
  }

  getEntityPaging(page: WpLangContentPage, entity: string, search: string) {
    return this.http.post<ReturnResult<any>>(`${this.baseUrl}/GetEntityPaging?entity=${entity}&search=${search}`, page);
  }

  getAdditionalData(id: number, entity: string) {
    return this.http.get<ReturnResult<any>>(`${this.baseUrl}/AdditionalData?id=${id}&entity=${entity}`);
  }

  saveTranslation(data: WPLangContent) {
    return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}`, data);
  }

  getTranslationByReference(type: string, id: string, lang: string) {    
    return this.http.get<ReturnResult<WPLangContent>>(`${this.baseUrl}/ByReference?refType=${type}&refId=${id}&lang=${lang}`);
  }

  getWpLangContentsByIdAndReferenceType(page: Page, refId: string = "", refType: string ="")
  {
    return this.http.post<ReturnResult<any>>(`${this.baseUrl}/GetWpLangContentsByIdAndReferenceType?refId=${refId}&refType=${refType}`, page);
  }

  getEntityByIdAndReference(refType: string, refId: number) {
    let params = new HttpParams()
      .set('refType', refType)
      .set('refId', refId?.toString());
    return this.http.get<ReturnResult<any>>(`${this.baseUrl}/GetEntityByIdAndReference`, { params });
  }
  
  getAllCurrentLanguageCodeByIdAndReference(refType: string, refId: string) 
  {
    let params = new HttpParams()
      .set('refType', refType)
      .set('refId', refId);
    return this.http.get<ReturnResult<string[]>>(`${this.baseUrl}/GetAllCurrentLanguageCodeByIdAndReference`, { params });  
  }

  deleteTranslation(id: number) {
    return this.http.delete<ReturnResult<boolean>>(`${this.baseUrl}/${id}`);
  }

  deleteMultipleTranslation(model: RemoveAtionIdList) {
    return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}/DeleteWpLangContents`, model);
  }

  getLatestRevisionId(referenceId: string | number, referenceType: string)
  {
    let params = new HttpParams()
      .set('referenceType', referenceType)
      .set('referenceId', referenceId);
    return this.http.get<ReturnResult<string>>(`${this.baseUrl}/GetLatestRevisionId`, { params });  
  }
  
  getCategoryLocationByCategoryId(referenceId: string) {
    let params = new HttpParams()
      .set('referenceId', referenceId);
    return this.http.get<ReturnResult<any[]>>(`${this.baseUrl}/GetCategoryLocationByCategoryId`, { params });
  }
}
